import axios from './configAxios';

export const getEntryReportsApi = async (url, isConfirmed) => {
	return await axios.get(`${url}&status=${isConfirmed}`);
};
